import classNames from 'classnames';
import React from 'react';
import ErrorLabel from '../../ErrorLabel';
import TopLabel, { BackgroundColor, InputVariantEnum } from '../../TopLabel';
import styles from './selectContainer.module.scss';
const SelectInputContainer = ({ id, label, className, hasValue, error, disabled, backgroundColor, children, focused, narrow, variant = InputVariantEnum.DEFAULT, }) => {
    const hasError = !!error;
    return (<label htmlFor={id} className={classNames(styles.selectInput, {
            [styles.error]: hasError,
            [styles.cloud]: BackgroundColor.CLOUD === backgroundColor,
            [styles.fog]: BackgroundColor.FOG === backgroundColor,
            [styles.narrow]: narrow,
        }, className)}>
      <div className={styles.selectInner}>
        {variant === InputVariantEnum.LABEL_OUTSIDE && (<TopLabel label={label} focused={focused} hasValue={hasValue} disabled={disabled} isError={hasError} variant={InputVariantEnum.LABEL_OUTSIDE}/>)}
        {children}
        {variant === InputVariantEnum.DEFAULT && (<TopLabel label={label} focused={focused} hasValue={hasValue} backgroundColor={backgroundColor} disabled={disabled} isError={hasError} variant={InputVariantEnum.DEFAULT} hideFromSRWhenInactive/>)}
        {hasError && <ErrorLabel error={error}/>}
      </div>
    </label>);
};
export default SelectInputContainer;
